import { render, staticRenderFns } from "./regularizar-esam.vue?vue&type=template&id=5bbfea63"
import script from "./regularizar-esam.vue?vue&type=script&lang=js"
export * from "./regularizar-esam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports